import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Grid, Card, CardContent, CardHeader, IconButton, Button, Avatar, Menu, MenuItem, Typography, FormControl, OutlinedInput, TextField, Modal, Box, Divider, InputLabel, Select, CardActions, Backdrop, CircularProgress } from '@mui/material';
// import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import OperationsHeader from './OperationsHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, KeyboardArrowLeftRounded, MoreHorizOutlined, CloseOutlined } from '@mui/icons-material';
import { toast } from 'react-toastify';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];
    };
}

export interface IState {
    route_id: string;
    pickup_details: any;
    customer_details: any;
    pageSize: number;
    anchorEl: any;
    transaction_data: any[];
    showEditPickupDetails: any;
    pickup_slot: any;
    agent: any;
    location: any;
    status: any;
    payment: any;
    showEditCustomerDetails: any;
    name: any;
    mobile: any;
    email: any;
    house_number: any;
    street: any;
    locality: any;
    state: any;
    pincode: any;
    landmark: any;
    attended_customer: any;
    showLoader: boolean;
    hierarchies: any;
}

class BagDetails extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            route_id: this.props.match.params.id,
            pickup_details: {},
            customer_details: {},
            pageSize: 5,
            anchorEl: null,
            transaction_data: [],
            showEditPickupDetails: false,
            pickup_slot: '',
            agent: '',
            location: '',
            status: '',
            payment: '',
            showEditCustomerDetails: false,
            name: '',
            mobile: '',
            email: '',
            house_number: '',
            street: '',
            locality: '',
            state: 'Telangana',
            pincode: '',
            landmark: '',
            attended_customer: '',
            showLoader: false,
            hierarchies: [],
        }
    }
    public componentDidMount(): void {
        // axios.get(`routes`).then(response => {
        //     this.setState({ routes: response.data.data })
        // });
        // this.setState({
        //     pickup_details: {
        //         "pickup_id": 2266714,
        //         "pickup_type": "community",
        //         "batch": "#334423(pending)",
        //         "pickup_date": "2023-09-13",
        //         "pickup_slot": "Morning",
        //         "agent": "Not assigned",
        //         "zone": "Not Selected",
        //         "location": "Hyderabad",
        //         "status": "Pending",
        //         "payment": "Not applicable",
        //         "pickup_added": "2023-09-13 01:00:38",
        //         "qr_code_canned": "Not scanned yet"
        //     },
        //     customer_details: {
        //         "name": "S. Shanmukha Rao",
        //         "mobile": "9988667658",
        //         "email": "arjun.shasha2@gmail.com",
        //         "house_no": "7",
        //         "street": "Hill County Road",
        //         "locality": "Not assigned",
        //         "city": "Hyderabad",
        //         "state": "Telangana",
        //         "pincode": "500032",
        //         "landmard": "Not assigned",
        //         "attended_customer": "Not assigned",
                
        //     },
        //     transaction_data: [
        //         {
        //           "id": 342,
        //           "type": "Credit",
        //           "title": "Payment from Client A",
        //           "amount": 378,
        //           "updated": "2023-06-19"
        //         },
        //         {
        //           "id": 123,
        //           "type": "Debit",
        //           "title": "Grocery Shopping",
        //           "amount": 55.75,
        //           "updated": "2023-06-20"
        //         },
        //         {
        //           "id": 567,
        //           "type": "Credit",
        //           "title": "Salary Deposit",
        //           "amount": 2500,
        //           "updated": "2023-06-21"
        //         },
        //         {
        //           "id": 999,
        //           "type": "Debit",
        //           "title": "Restaurant Dinner",
        //           "amount": 75.5,
        //           "updated": "2023-06-22"
        //         },
        //         {
        //           "id": 789,
        //           "type": "Credit",
        //           "title": "Online Sales Revenue",
        //           "amount": 650.25,
        //           "updated": "2023-06-23"
        //         }
        //       ]
              
        // })
        this.fetchBagDetails();
        this.fetchAccessibleHierarchiesList();
    }

    public fetchBagDetails () {
        this.setState({showLoader: true});
        let data = {
            "hierarchies": this.props.user.selectedHierarchyIds,
        }
        axios.get(`getDistributionDetails/${this.state.route_id}`, {params: data}).then((response: any) => {
            if(response.data.success){
                let data = response.data.data;
                console.log("data", data);
                this.setState({pickup_details: data, showLoader: false});
            } else {
                this.setState({ showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        }).catch((error) => {
            this.setState({showLoader: false });
            toast.error(error.response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    public fetchAccessibleHierarchiesList() {
        axios.get(`accessibleHierarchiesList`).then(response => {
            let hierarchies: any = [];
            if (response.data.success) {
                response.data.data.map((hierarchy: any) => {
                    hierarchies[hierarchy.id] = hierarchy;
                });
            }
            this.setState({ hierarchies: hierarchies });
            console.log(this.state.hierarchies);
        })
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const open = Boolean(this.state.anchorEl);

        const handleRouteMoreOptions = (event: React.MouseEvent<HTMLElement>) => {
            this.setState({ anchorEl: event.currentTarget });
        };
        const closeRouteMoreOptions = () => {
            setTimeout(() => {
                this.setState({ anchorEl: null });
            }, 1);
        };

        const handleEditPickupDetails = ((data: any) => {
            closeRouteMoreOptions();
            this.setState({
                showEditPickupDetails: true,
                
            })
        }) 

        const handleEditCustomerDetails = ((data: any) => {
            closeRouteMoreOptions();
            this.setState({
                showEditCustomerDetails: true,
                
            })
        })

        const handleUpdatePickupDetails = (() => {
            // this.setState({ showLoader: true });
        })


        const user_barcode_column: any = [
            
            {
                headerName: "Id",
                field: "id",
                width: 120
            },
            {
                headerName: "Barcode",
                field: "barcode",
                width: 200
            },
            {
                headerName: "Linked Date",
                field: "linked_date",
                width: 200
            },
            {
                headerName: "Reached User",
                field: "reached_user",
                width: 200,
                renderCell: (params: GridCellParams) => (
                    <Typography className={(params.row.reached_user == 1) ? 'statusTextSuccess' : 'statusTextError'}>{params.row.reached_user == 1 ? "Yes" : "No"}</Typography>
                )
               
            },
            {
                headerName: "Back to Warehouse",
                field: "reached_warehouse",
                width: 200,
                renderCell: (params: GridCellParams) => (
                    <Typography className={(params.row.reached_warehouse == 1) ? 'statusTextSuccess' : 'statusTextError'}>{params.row.reached_warehouse == 1 ? "Yes" : "No"}</Typography>
                )
            },
        ];

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                    // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <OperationsHeader />
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                avatar={
                                    <Button size="small" variant='outlined' className='customBackButton' component={Link} to={'/operations/bag-distribution'}><KeyboardArrowLeftRounded /></Button>
                                }
                                title="Bag Details"
                                className="text-left"
                                // action={
                                //     <IconButton aria-label="route-more-options-button" sx={{ outline: 'none !important' }} onClick={(e: any) => handleRouteMoreOptions(e)}>
                                //         <MoreHorizOutlined id="route-more-options-button" sx={{ outline: 'none !important' }} />
                                //         <Menu
                                //             id="route-more-options-menu"
                                //             aria-labelledby="route-more-options-button"
                                //             anchorEl={this.state.anchorEl}
                                //             open={open}
                                //             onClose={() => closeRouteMoreOptions()}
                                //             anchorOrigin={{
                                //                 vertical: 'top',
                                //                 horizontal: 'left',
                                //             }}
                                //             transformOrigin={{
                                //                 vertical: 'top',
                                //                 horizontal: 'left',
                                //             }}
                                //         >
                                //             <MenuItem className='customMenuItem' onClick={() => handleEditPickupDetails(this.state.pickup_details)}>{t("Edit Pickup Details")}</MenuItem>
                                //             <MenuItem className='customMenuItem' onClick={() => handleEditCustomerDetails(this.state.customer_details)}>{t("Edit Customer Details")}</MenuItem>
                                            
                                //             {/* <MenuItem className='customMenuItem' onClick={() => closeRouteMoreOptions()}>Delete Route</MenuItem> */}
                                //         </Menu>
                                //     </IconButton>
                                // } 
                                />
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item md={6} xs={12}>
                                        <Card className="customCardDetails">
                                            <CardHeader title="Bag Details"/>
                                            <CardContent>
                                                <Grid container spacing={2}>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Bag ID: 
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        #{this.state.pickup_details.id}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Bag Type
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {this.state.pickup_details.distribution_type}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Distribution Date
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {this.state.pickup_details.distribution_date}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Agent
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {this.state.pickup_details.agent_name}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Community
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {this.state.pickup_details.community?.name}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Location
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {this.state.pickup_details.community?.address}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Status
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {this.state.pickup_details.status}
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <Card className="customCardDetails">
                                            <CardHeader title="Customer Details"/>
                                            <CardContent>
                                                <Grid container spacing={2}>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Name
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsValue'>
                                                        {this.state.pickup_details.user?.name}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Mobile
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className={'detailsValue ' + ((this.state.pickup_details.status == 'Active') ? 'statusTextSuccess' : '')}>
                                                        {this.state.pickup_details.user?.phone}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Email
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className={'detailsValue ' + ((this.state.pickup_details.status == 'Active') ? 'statusTextSuccess' : '')}>
                                                        {this.state.pickup_details.user?.email}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        House No.
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className={'detailsValue ' + ((this.state.pickup_details.status == 'Active') ? 'statusTextSuccess' : '')}>
                                                        {this.state.pickup_details.customer?.location}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        City
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className={'detailsValue ' + ((this.state.pickup_details.status == 'Active') ? 'statusTextSuccess' : '')}>
                                                        {this.state.hierarchies[this.state.pickup_details?.hierarchy_id]?.name}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Terms and Conditions
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className={'detailsValue ' + ((this.state.pickup_details.status == 'Active') ? 'statusTextSuccess' : '')}>
                                                        {this.state.pickup_details?.customer?.tc_accepted == 1 ? "Accepted": "Not Accepted"}
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className='detailsTitle'>
                                                        Survey
                                                    </Grid>
                                                    <Grid item md={6} xs={6} className={'detailsValue ' + ((this.state.pickup_details.status == 'Active') ? 'statusTextSuccess' : '')}>
                                                        {this.state.pickup_details?.customer?.is_survey_completed == 1 ? "Completed": "Not Accepted"}
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                title="User Barcodes"
                                className='text-left'
                            />
                            <CardContent>
                                <DataGrid
                                    aria-label='user-barcodes'
                                    columns={user_barcode_column}
                                    rows={this.state.pickup_details?.user_barcodes}
                                    autoHeight={true}
                                    // components={{
                                    //     MoreActionsIcon: EditOutlined,
                                    // }}
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default withRouter(withTranslation()(BagDetails))